import { Button, Group, Paper, Stack, Title } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconTrash } from '@tabler/icons-react';
import { CopyText } from '#/components/ui/tickets/components/CopyText.tsx';
import { useAccountByIdData } from '../hooks/useAccountData.ts';
import { DeleteAccountModal } from './DeleteAccountModal.tsx';
import { SectionState } from './SectionState.tsx';

const AccountDetailSection = ({ accountId }: { accountId: string }) => {
  const { data, error, isPending } = useAccountByIdData(accountId);
  const [
    isDeleteModalOpened,
    { open: openDeleteModal, close: closeDeleteModal },
  ] = useDisclosure(false);

  const renderContent = () => {
    if (isPending) return <SectionState status="loading" />;
    if (error) return <SectionState status="error" error={error} />;

    const { id, email, phoneNumber } = data;

    return (
      <Group justify="space-between" align="flex-start" wrap="nowrap">
        <Stack gap="xs">
          <Title order={2}>
            {email} {phoneNumber ? `| ${phoneNumber}` : ''}
          </Title>
          <Group gap={4}>
            <CopyText style={{ color: 'gray' }} size="sm">
              {id}
            </CopyText>
          </Group>
        </Stack>

        <Button
          variant="light"
          color="red"
          leftSection={<IconTrash size={16} />}
          onClick={openDeleteModal}
        >
          刪除帳號
        </Button>

        <DeleteAccountModal
          opened={isDeleteModalOpened}
          accountId={id}
          email={email}
          onClose={closeDeleteModal}
        />
      </Group>
    );
  };

  return (
    <Paper radius="lg" p="xl" shadow="xs">
      {renderContent()}
    </Paper>
  );
};

export { AccountDetailSection };
